<template>
  <div class="bg" ref="scrollArea" @wheel="handleScroll">
    <!-- banner -->
    <div class="top">
      <el-carousel height="38rem" ref="carousel" indicator-position="none" style="backgroundColor:#fff">
        <el-carousel-item>
          <div class="banner">
            <div class="img"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/banner1.jpg"></div>
            <div class="value">We Are Your Research Team on the Ground in Asia</div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- Who we are | What we do -->
    <div class="intro">

      <!-- <div class="img">
        <div class="image4"></div>
        <div class="image2"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/aboutUs/team4.jpg"></div>
        <div class="image1"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/aboutUs/team5.jpg"></div>
        <div class="image3"></div>
      </div> -->
      <div class="text">
        <div class="title">
          Who we are | What we do
        </div>
        <div class="value">
          We are an international-local company—we provide local insights in carrying out internationally recognized methodologies and practices for clients all over the globe.</br> We support our clients’ success by providing Qualitative and Quantitative services. Our proprietary Panels of Physicians, Patients, & Consumers provide candid feedback from your study targets with clear implications for your business needs. We also develop and apply innovative research technologies/practices in order to provide quality results efficiently.
        </div>
      </div>

    </div>

    <!-- Our Purpose -->
    <div class="Purpose">
      <!-- <div class="image"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/aboutUs/purpose.jpg"></div> -->
      <div class="text">

        <div class="title">
          Our Purpose
        </div>
        <div class="value">
          We contribute to our clients' success by providing data, information, & insight-- Direct feedback from our client’s research targets.

        </div>
      </div>
    </div>

    <!-- Our Team -->
    <div class="team">
      <!-- <div class="image1"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/aboutUs/team2.jpg"></div> -->
      <div class="text">
        <div class="title">
          Our Team
        </div>
        <div class="value">
          We contribute to our clients’ success by providing data, information, & insight directly from our research targets’ feedback.

          <span @click="btn('/team?source=aboutUs')">→ Meet the Team</span>
        </div>
      </div>
    </div>
    <!-- Our Clients Say -->
    <div class="Clients">
      <div class="text">
        <div class="title">
          What our clients say
        </div>
        <div class="value">
          <el-carousel ref="carousel" indicator-position="none">
            <el-carousel-item v-for="(item,index2) in clients" :key="index2">
              <div class="says">{{item.value}}</div>
            </el-carousel-item>

          </el-carousel>

        </div>
      </div>

    </div>

    <!-- We grow together with -->
    <div class="partner">
      <div class="text">
        <div class="title">
          We grow together with
        </div>
        <div class="value">
          <a href="https://www.intellus.org/" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/aboutUs/intellus.png" class="one"></a>
          <a href="https://www.qrca.org/" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/aboutUs/qrca.png" class="two"></a>
          <a href="https://www.jmra-net.or.jp/" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/aboutUs/jmar-net.png" class="three"></a>
          <a href="http://www.cmra.org.cn/" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/aboutUs/cphmra.png" class="four"></a>
          <a href="https://www.quirks.com/" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/aboutUs/quirks.png" class="five"></a>
          <a href="http://www.cmra.org.cn/" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/aboutUs/cmra.png" class="six"></a>
          <a href="https://www.appa360.com/?source=appa_holdendata" target="_blank"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/appa/APPA.png" class="seven"></a>

        </div>
      </div>
    </div>

    <!-- CMRA Certificate logo   -->
    <div class="cmra">
      <div class="one">
        <div class="value">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/aboutUs/cmraLogo.png" alt="">
        </div>
        <div class="title">
          <div class="firstTitle">CMRA</div>
          <div class="secondTitle">Market research personal information security protection requirements</div>
        </div>
      </div>
      <div class="two">
        <div class="title">
          <div class="firstTitle">ISO</div>
          <div class="secondTitle">Market, opinion，social research, insights and data analytics</div>
        </div>
        <div class="value">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/djs/2023/09/06/8/1693988218250.png" alt="">
        </div>

      </div>

    </div>

    <!-- map -->
    <asia-map />
    <!-- Download our Panel Book -->
    <down-load />

    <!-- news -->
    <div class="news">
      <div class="bigtitle">Latest News & Release</div>
      <div class="newsList">
        <div class="topnews">

          <div class="topNews" v-for="(item,index) in topFlag.slice(0,1)" :key="index" @click="toDetail(item.id,item.subscribe,item.newsTitle)">
            <img :src="item.logo">
            <div>
              <div>
                <div class="label">
                  {{item.firstLabel}}
                </div>
                <div class="label" v-for="label in item.othersLabel.split(',').slice(0,3)">
                  {{label}}
                  <!-- .split(",") -->
                </div>
              </div>

              <div class="title">
                {{ item.newsTitle }}
              </div>
            </div>
            <div class="newsDesc overflowMulityText3">
              {{ item.newsDesc }}
            </div>

          </div>
          <div @click="btn('/media?source=index')" class="more">read more</div>
        </div>
        <div class="notopnews">

          <div class="one" v-for="(item,index) in newsList.slice(0,3)" :key="index" @click="toDetail(item.id,item.subscribe,item.newsTitle)">
            <img :src="item.logo">
            <div>
              <div>
                <div class="label">
                  {{item.firstLabel}}
                </div>
                <div class="label" v-for="label in item.othersLabel.split(',').slice(0,3)">
                  {{label}}
                  <!-- .split(",") -->
                </div>
              </div>

              <div class="title">
                {{ item.newsTitle }}
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
    <el-dialog title="" :visible="DialogShow" width="45%" @close="DialogShow=false">
      <span>
        <div class="from">
          <div class="formtitle">Please fill in your information</div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-form-item label="First Name" prop="firstname">
              <el-input v-model="ruleForm.firstname" />
            </el-form-item>
            <el-form-item label="Last Name" prop="lastname">
              <el-input v-model="ruleForm.lastname" />
            </el-form-item>
            <el-form-item label="Email" prop="mail">
              <el-input v-model="ruleForm.mail" />
            </el-form-item>
            <el-form-item label="Company" prop="company">
              <el-input v-model="ruleForm.company" />
            </el-form-item>
            <!-- <div>We need your permission to stay in touch.</div> -->
            <el-form-item prop="check" style="width:100%">

              <input class="check" type="checkbox" v-model="ruleForm.check"><span style="word-break: break-word;">Yes, I would like to receive digital communications from Holden brands. I may opt-out of communications at any time using the unsubscribe link at the bottom of any email communication.</span>
            </el-form-item>
          </el-form>

        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="DialogShow = false">cancel</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">submit</el-button>

      </span>
    </el-dialog>
  </div>
</template>

<script>
const defaultForm = {
  action: "News",
  actionCase: "Readnews",
  targetName: "",
  mail: "",
  firstname: "",
  lastname: "",
  company: "",
  check: true
};
import { getNewsList, getCustomerList, actionRecords, advertisementFlow } from "@/api/api";
import download from "downloadjs";
import DownLoad from "@/components/downLoad";
import AsiaMap from "@/components/asiaMap";

export default {
  data() {
    const check = (rule, value, callback) => {
      if (value == false) {
        return callback(new Error("Please complete this required field"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: JSON.parse(JSON.stringify(defaultForm)),
      rules: {
        firstname: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        lastname: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        company: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        mail: [
          { required: true, message: "Please complete this required field", trigger: "blur" },
          { type: "email", message: "Email must be formatted correctly.", trigger: ["blur"] }
        ]
        // check: [{ required: true, message: "Please complete this required field", trigger: "blur" }, { validator: check }]
      },
      DialogShow: false,
      autoplay: true,
      scroll: 0,
      caseList: [],
      downloadfile: "",
      url: "",
      slide: 0,
      sliding: null,
      newsList: [],
      clients: [
        { value: "“ Great work helping us close so fast! ”" },
        { value: "“ As always, the Holden team consistently responds to proposal requests in a clear, concise, and quick way, and it is always a pleasure to work with the team. ”" },
        { value: "“ Thank you for making my experience, as well as my clients experience a great one! We will definitely be looking forward to working with the team again in the near future :) ”" },
        { value: "“ Your team always does a wonderful job and it's always a pleasure working with you all. I know my projects will be in good hands which takes off the pressure from my end. Thank you and keep doing what you do ”" },
        { value: "“ Holden did a great job setting expectations on what can be realistically delivered per week - this helped greatly with client management on our end. Thank you! ”" },
        { value: "“ Fabulous recruit in India despite the global pandemic difficulties! ”" },
        { value: "“ I would definitely work with you again, very well done! ”" },
        { value: "“ Great communication and delivered earlier than what we expected  Thank you :) ”" },
        { value: "“ Team was awesome and responsive. Fielding went as promised. Please keep it up. ”" },
        { value: "“ Great team to work with!!!Nicole and the Taiwan team were responsive and great to work with.Nicole and her Team are always efficient with various back matching and recontact queries. It make fielding much easier! Thanks Nicole and Team :D ”" },
        { value: "“ Jenny was great and helped handle fieldwork despite some difficult sub quota difficulties! ”" },
        { value: "“ You are doing a great job and the team makes things easier for everyone which is very much appreciated and it is exactly what we expect from a panel partner ”" },
        { value: "“ As working with Nicole has been such a pleasure. She is friendly, efficient and always reliable. Thank you for all your hard work in 2021. We hope to be able to continue working with Nicole and Holden for a successful 2022 ”" }
      ],
      topFlag: []
    };
  },
  created() {
    this.getNewsList();
    this.getCustomerList();
    this.loading();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
    //  this.getNewsList(2);
  },
  mounted() {
    //调用方法
    this.slideBanner();
  },

  components: { DownLoad, AsiaMap },
  methods: {
    handleScroll(event) {
      const container = this.$refs.scrollContainer;
      const delta = Math.sign(event.deltaY); // 获取滚动方向

      if (delta > 0) {
        container.scrollTop += window.innerHeight; // 向下滚动一整屏
      } else {
        container.scrollTop -= window.innerHeight; // 向上滚动一整屏
      }

      event.preventDefault(); // 阻止默认滚动行为
    },
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "aboutUs",
          source: "",
          information: "关于我们"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "aboutUs",
          source: this.$route.query.source,
          information: "关于我们"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    submitForm(formName) {
      let _this = this;
      // 数据写入表单
      _this.$refs[formName].validate(valid => {
        if (valid) {
          _this.ruleForm.fullName = _this.ruleForm.firstname + " " + _this.ruleForm.lastname;
          let ruleForm = {
            action: "News",
            actionCase: "Readnews",
            firstName: _this.ruleForm.firstname,
            fullName: _this.ruleForm.fullName,
            mail: _this.ruleForm.mail,
            company: _this.ruleForm.company
          };
          //   console.log(this.ruleForm);
          localStorage.setItem("form", JSON.stringify(this.ruleForm));
          var form = JSON.parse(localStorage.getItem("form"));
          form.targetName = this.submitTitle;
          console.log(form);
          // 提交表单数据
          actionRecords(form).then(res => {
            // console.log(form);
            // 如果没有cookie
            // 提交成功
            if (res.code == 10000) {
              // 关闭弹框
              this.DialogShow = false;
              // 存入cookie
              if (localStorage.getItem("agreeCookies")) {
                var val = localStorage.getItem("agreeCookies");
                var dataobj = JSON.parse(val);
                if (dataobj.val == "agree") {
                  this.$cookies.set("HoldenCookies", "panelDownloads");
                }
              } else if (this.$cookies.isKey("defaultcookies")) {
                this.$cookies.set("HoldenCookies", "panelDownloads");
              }
              // 跳转查看详情
              this.$router.push({ name: "newsDetail", query: { id: this.submitId, source: "aboutUs" } });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    loading() {
      this.$loading({
        lock: true,
        background: "rgba(255, 255, 255,1)"
      });
      setTimeout(() => {
        this.$loading().close();
      }, 700);
    },
    getCustomerList() {
      getCustomerList({
        pageSize: 4,
        pageIndex: 1,
        status: 1, //启用
        origin: 1, //前台
        isRecommend: 1, //是否推荐
        customerType: 1
      }).then(res => {
        if (res.code != 10000) {
          this.$message.error(res.msg || "查询案例分享失败");
          return;
        }
        this.caseList = res.datalist || [];
        this.allCount = res.allCount;
      });
    },
    /*轮播手滑切换*/
    startAuto() {
      if (this.autoplay == false) {
        this.autoplay = true;
      }
    },
    stopAuto() {
      if (this.autoplay == true) {
        this.autoplay = false;
      }
    },
    slideBanner() {
      let that = this;
      //选中item的盒子
      var box = document.querySelector(".el-carousel__container");
      //手指起点X坐标
      var startPoint = 0;
      //手指滑动重点X坐标
      var stopPoint = 0;

      //重置坐标
      var resetPoint = function() {
        startPoint = 0;
        stopPoint = 0;
      };

      //手指按下
      box.addEventListener("touchstart", function(e) {
        //手指按下的时候停止自动轮播
        that.stopAuto();
        //手指点击位置的X坐标
        startPoint = e.changedTouches[0].pageX;
      });
      //手指滑动
      box.addEventListener("touchmove", function(e) {
        //手指滑动后终点位置X的坐标
        stopPoint = e.changedTouches[0].pageX;
      });
      //当手指抬起的时候，判断图片滚动离左右的距离
      box.addEventListener("touchend", function(e) {
        console.log(e);
        console.log("1：" + startPoint);
        console.log("2：" + stopPoint);
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          resetPoint();
          return;
        }
        if (startPoint - stopPoint > 0) {
          resetPoint();
          that.$refs.carousel.next();
          return;
        }
        if (startPoint - stopPoint < 0) {
          resetPoint();
          that.$refs.carousel.prev();
          return;
        }
      });
    },
    toDetail(id, subscribe, newsTitle) {
      if (subscribe == 1 && !this.$cookies.isKey("HoldenCookies")) {
        this.submitId = id;
        this.DialogShow = true;
        this.submitTitle = newsTitle;
      }
      // 如果需要权限并且没有cookie
      else {
        this.$router.push({ name: "newsDetail", query: { id: id, source: "aboutUs" } });
      }
    },
    toDetailcase(id) {
      this.$router.push({ name: "caseDetail", query: { id: id } });
    },
    getNewsList() {
      getNewsList({
        pageSize: 0,
        pageIndex: 1,
        status: 1, //启用
        origin: 1 //前台
      }).then(res => {
        if (res.code != 10000) {
          this.$message.error(res.msg || "Failed to query news information");
          return;
        }
        console.log(res);
        this.newsList = res.datalist.filter(k => k.topFlag != 1);
        this.topFlag = res.datalist.filter(k => k.topFlag == 1);
      });
    },
    btn(path) {
      // 跳转页面
      this.$router.push({
        path
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.bg {
  // height: 100vh;
  background-image: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/aboutUs/bg.jpg");
  background-attachment: fixed;
}
.banner {
  width: 100%;
  height: 100%;
  // background-color: pink;
  position: relative;
  img {
    width: 100%;
  }
  .value {
    position: absolute;
    top: 15%;
    right: 7%;
    width: 40%;
    text-align: center;
    font-size: 60px;
    font-weight: 700;
    color: #003c50;
    text-shadow: 1px 1px #000;
  }
}
.intro {
  background-color: #fff;
  padding: 50px 100px;
  position: relative;
  overflow: hidden;
  .image1 {
    width: 400px;
    position: absolute;
    right: -20px;
    top: -35px;
    border-radius: 50%;
    img {
      width: 100%;
      border-radius: 50%;
    }
  }
  .image2 {
    width: 300px;
    position: absolute;
    top: 220px;
    right: 320px;
    border-radius: 50%;
    img {
      width: 100%;
      border-radius: 50%;
    }
  }
  .image3 {
    width: 50px;
    height: 50px;
    background-color: #ccc;
    border-radius: 50%;
    position: absolute;
    right: 60px;
    // bottom: 270px;
    top: 320px;
  }
  .image4 {
    width: 220px;
    height: 220px;
    border-radius: 50%;
    position: absolute;
    right: 110px;
    top: 400px;
    // bottom: 20px;
    background-color: rgb(101, 158, 223);
  }

  .text {
    width: 100%;
    .title {
      font-size: 40px;
      font-weight: 700;
      color: #0cb4ec;
    }
    .value {
      // color: rgb(110, 105, 105);
      font-size: 23px;
      // text-align: justify;
      padding: 50px;
      // font-weight: 700;
    }
  }
}
.Purpose {
  // background-color: #f2f2f2;
  background-color: #fff;

  padding: 50px 100px;
  position: relative;
  overflow: hidden;
  .image {
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 100%;
    overflow: hidden;
    img {
      // width:100%;
      height: 100%;
      border-radius: 0 20px 20px 0;
    }
  }
  .text {
    width: 100%;
    // float: right;
    .title {
      font-size: 35px;
      font-weight: 700;
      color: #2cb1e9;
    }
    .value {
      // color: #62778c;
      font-size: 23px;
      // text-align: center;
      padding: 50px;
      // font-weight: 700;
    }
  }
}
.team {
  // background-color: #2cb1e9;
  background-color: #fff;

  padding: 50px 100px;
  position: relative;
  overflow: hidden;
  .image1 {
    width: 850px;
    position: absolute;
    top: 60px;
    // bottom: -40px;
    right: -210px;
    border-radius: 50%;
    border: 10px dotted rgb(9, 58, 104);
    padding: 10px;

    img {
      // transform: rotateY(180deg);
      width: 100%;
      border-radius: 50%;
      // border: 10px dotted #69b0da;
    }
  }

  .text {
    width: 100%;
    .title {
      font-size: 35px;
      font-weight: 700;
      color: #2cb1e9;
      // text-shadow: 1px 1px #62778c;
    }
    .value {
      // color: #fff;
      font-size: 23px;
      // text-align: justify;
      padding: 50px;
      // font-weight: 700;
    }
    span {
      // color: #fff;
      text-shadow: 1px 1px #62778c;
      cursor: pointer;
      float: right;
      font-size: 20px;
      margin-top: 65px;
      text-decoration: underline;
    }
    span:hover {
      color: #0087d7;
    }
  }
}
.Clients {
  background-color: rgba(255, 255, 255, 0.7);
  text-align: center;
  // padding: 100px;
  position: relative;
  overflow: hidden;
  padding-top: 80px;
  .text {
    .title {
      // padding: 100px 100px 0 100px;

      font-size: 35px;
      font-weight: 700;
      color: #003c50;
    }
    .value {
      color: rgb(110, 105, 105);
      font-size: 23px;
      text-align: center;
      vertical-align: center;
      padding: 50px;
      padding-bottom: 10px;
      font-weight: 700;
      .says {
        margin: 0 auto;
        width: 85%;
      }
    }
  }
}
.partner {
  background-color: #f8f9fa;
  padding: 80px 100px 20px 120px;
  position: relative;
  overflow: hidden;
  .title {
    font-size: 40px;
    font-weight: 700;
    margin-bottom: 40px;
    color: #2cb1e9;
  }
  .value {
    img {
      width: 20%;
      margin: 2% 4%;
    }
    .two {
      width: 25%;
    }
    .three {
      width: 30%;
    }
    .six {
      width: 15%;
    }
    .five {
      width: 15%;
    }
    .seven {
      width: 18%;
    }
  }
}
.cmra {
  background-color: #fff;
  padding: 100px 120px;
  overflow: hidden;
  text-align: center;
  display: flex;
  justify-content: space-between;
  .one,
  .two {
    width: 45%;
    display: flex;
    // align-items: center;
    .value {
      width: 300px;
      img {
        width: 100%;
      }
    }
    .title {
      .firstTitle {
        font-size: 40px;
        font-weight: 700;
        color: #2cb1e9;
      }
      .secondTitle {
        font-size: 23px;
      }
    }
  }
  .two {
    .value {
      img {
        padding: 0 20px;
      }
    }
  }

}
.news {
  padding: 0px 120px;
  font-size: 18px;
  position: relative;
  background-color: #fff;

  .bigtitle {
    font-size: 40px;
    font-weight: 700;
    color: #ccc;
  }
  .more {
    // width: 160px;
    padding: 0 20px;
    font-size: 16px;
    color: #409eff;
    background-color: #ecf5ff;
    border: 1px solid #409eff;
    border-radius: 8px;
    text-align: center;
    position: absolute;
    left: 120px;
    bottom: 20px;
  }
  .more:hover {
    cursor: pointer;
    color: #2cb1e9;
  }
  .newsList {
    // text-align: center;
    display: flex;
    justify-content: space-between;
    // flex-wrap: wrap;
    .topnews {
      width: 50%;
      height: 100%;
      .topNews {
        border: 1px solid #d5dbe5;
        border-radius: 8px;
        box-shadow: 4px 4px 4px 0 #d5dbe5;
        padding: 14px;
        cursor: pointer;
        margin-bottom: 60px;

        img {
          width: 100%;
        }
        .title {
          margin-top: 10px;
          font-weight: 700;
        }
        .label {
          margin: 15px 10px 0 0;
          font-size: 12px;
          display: inline-block;
          padding: 0.7px 7.5px 2px;
          background: #e8f2ff;
          border-radius: 4px;
          color: #2186c8;
        }
        .newsDesc {
          margin-top: 20px;
        }
      }
    }
    .notopnews {
      width: 47%;
    }
    .one {
      display: flex;
      cursor: pointer;
      padding: 14px;
      width: 100%;
      margin: 0px auto 20px;
      border: 1px solid #d5dbe5;
      border-radius: 8px;
      box-shadow: 4px 4px 4px 0 #d5dbe5;
      img {
        width: 300px;
        height: 170px;
      }
      .title {
        margin-left: 10px;
      }
      .label {
        margin-left: 10px;
        font-size: 12px;
        display: inline-block;
        padding: 0.7px 7.5px 2px;
        background: #e8f2ff;
        border-radius: 4px;
        color: #2186c8;
      }
    }
    .two {
      width: 40%;
    }
  }
}
.check {
  margin-right: 10px;
}
/deep/ .el-dialog__wrapper {
  .el-dialog {
    width: 100% !important;
    .el-dialog__footer {
      .el-button {
        font-size: 70px;
        padding: 20px;
      }
    }
  }
}
.from {
  // width: 60%;
  // margin: 80px auto;
  // padding: 30px;
  // transform: scale(1.3);
  padding-top: 0px;
  .formtitle {
    text-align: center;
    font-weight: 700;
    font-size: 25px;
    color: #ff0000;
  }
  @media screen and (max-width: 570px) {
    .formtitle {
      font-size: 45px;
    }
  }
  .el-form {
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
    padding: 10px;
    /deep/ .el-form-item {
      display: inline-block;
      display: flex;
      // flex-wrap: wrap;
      justify-content: start;
      &:nth-child() {
        .el-form-item__label {
          // margin-left: 7px;
        }
      }
      &:not(.text) {
        // width: 50%;
      }
      &.text {
        width: 100%;
      }
      .el-form-item__content {
        font-size: 11px;
        line-height: 20px;
        flex: 1;
        .el-input {
          width: 238px !important;
        }
      }

      .el-form-item__label {
        width: 125px;
        font-size: 15px;
        display: block;
        font-weight: normal;
      }
      .el-textarea__inner {
        min-height: 104px !important;
      }
      .el-input__inner,
      .el-textarea__inner {
        background: #fafafa;
        border: 1px solid #e6e6e6;
        border-radius: 7px;
        font-size: 15px;
        width: 390px;
      }
      @media screen and (max-width: 576px) {
        .el-input__inner {
          font-size: 35px;
          width: 700px;
          height: 80px;
        }
        .el-form-item__label {
          font-size: 35px;
          width: 250px;
        }
        .el-form-item__content {
          font-size: 30px;
          line-height: 40px;
        }
      }
      .el-form-item__error {
        font-size: 12px !important;
      }
    }
  }
  & > * {
    margin: 20px;
  }
  div {
    margin-top: 12px;
  }
  .button {
    margin: 0 auto;
    margin-top: 20px;
    background: #217df6;
    font-size: 13px;
    color: #fff;
    border-radius: 7px;
    text-align: center;
    width: 150px;
    padding: 10px;
    // height: 34px;
    // line-height: 34px;
    cursor: pointer;
  }
  @media screen and (max-width: 576px) {
    .button {
      font-size: 35px;
    }
  }
}
@media screen and (max-width: 576px) {
  .banner {
    .value {
      width: 45%;
      font-size: 80px;
    }
  }
  .intro {
    .img {
    }
    .image1 {
      width: 800px;
    }
    .image2 {
      width: 600px;
      right: 640px;
      top: 440px;
    }
    .image3 {
      width: 100px;
      height: 100px;
      right: 120px;
      top: 640px;
    }
    .image4 {
      width: 440px;
      height: 440px;
      top: 800px;
      right: 220px;
    }
    .text {
      padding-top: 120px;
      width: 100%;
      .title {
        font-size: 80px;
      }
      .value {
        font-size: 70px;
      }
    }
  }
  .Purpose {
    .text {
      // width: 49%;
      .title {
        font-size: 80px;
      }
      .value {
        font-size: 70px;
      }
    }
  }
  .team {
    .image1 {
      width: 1500px;
    }
    .text {
      padding-top: 120px;
      width: 100%;
      .title {
        font-size: 80px;
      }
      .value {
        font-size: 70px;
      }
      span {
        font-size: 70px;
      }
    }
  }
  .Clients {
    height: 1300px;
    .text {
      .title {
        font-size: 80px;
      }
      .value {
        font-size: 70px;
        padding-bottom: 30px;
        height: 600px;
      }
    }
  }
  .partner {
    .title {
      font-size: 80px;
    }
    .value {
      text-align: center;

      img {
        width: 80%;
        margin: 10% 8%;
      }
      .two {
        width: 80%;
      }
      .three {
        width: 80%;
      }
      .five {
        width: 80%;
      }
      .six {
        width: 60%;
      }
      .seven {
        width: 80%;
      }
    }
  }
  .cmra {
    display: block;
    .one,
    .two {
      width: 100%;
      align-items: center;

      .value {
        width: 1500px;
      }
      .title {
        .firstTitle {
          font-size: 80px;
        }
        .secondTitle {
          font-size: 70px;
        }
      }
    }
    .one {
      padding-bottom: 100px;
    }
    .two {
      .value {
        img {
          padding: 0 50px;
        }
      }
    }
  }
  .news {
    padding-bottom: 100px;
    .bigtitle {
      font-size: 80px;
    }
    .more {
      font-size: 40px;
      bottom: 10px;
    }
    .newsList {
      display: block;
      .topnews {
        width: 100%;
        .topNews {
          .title {
            font-size: 70px;
          }
          .label {
            font-size: 50px;
            margin-bottom: 10px;
          }
          .newsDesc {
            font-size: 60px;
          }
        }
      }
      .notopnews {
        width: 100%;
      }
      .one {
        flex-wrap: wrap;

        img {
          width: 100%;
          height: 800px;
        }
        .label {
          font-size: 50px;
          margin-bottom: 10px;
        }
        .title {
          font-size: 70px;
        }
      }
    }
  }
}
</style>
<style scoped>
/deep/.el-carousel__arrow {
  width: 50px;
  height: 50px;
  font-size: 40px;
}
@media screen and (max-width: 576px) {
  /deep/ .el-carousel__arrow {
    width: 100px;
    height: 100px;
    font-size: 80px;
  }
  /deep/ .el-carousel__container {
    height: 1000px;
  }
}
</style>